import React, { useContext, useEffect, useRef, useState } from "react";
import RegisterLayout from "./RegisterLayout";
import { makeDeleteCall, makeGetCall, makePostCall } from "../../../effects/requests";
import { endPoints } from "../../../utils/endpoints";
import { emptyFunction, showToast } from "../../../utils";
import { MyContext } from "../../../context";

interface StepMediaProps {
    onNext: () => void;
    onPrevious: () => void;
}

const StepMedia: React.FC<StepMediaProps> = ({ onNext, onPrevious }) => {
    const [previews, setPreviews] = useState<any>([]);
    const [medias, setMedias] = useState<any>([]);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [dragging, setDragging] = useState(false);

    const { userData } = useContext(MyContext)

    const handleFiles = (files: FileList | null) => {
        if (!files) return;
        if (previews?.length > 10) {
            showToast('Ypu have reached upload limits.', 'error')
            return
        }
        const urls: any = [];
        const mediasFiles = [...medias];
        Array.from(files).forEach((file) => {
            if (file.type.startsWith("image/")) {
                urls.push({
                    id: null,
                    image: URL.createObjectURL(file)
                });
            }
        });
        mediasFiles.push(files?.[0]);
        setMedias(mediasFiles)
        setPreviews((prev: any) => [...prev, ...urls]);
    };

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setDragging(false);
        handleFiles(e.dataTransfer.files);
    };

    const handleSubmit = () => {
        if (medias?.length > 0) {
            medias?.map((item: any) => {
                const fd = new FormData();
                fd.append('image', item)
                makePostCall(endPoints.USER_PORTFOLIO, fd).then(emptyFunction).catch(emptyFunction)
            })
        }
        onNext();
    }

    const fetchUserPortfolio = () => {
        makeGetCall(endPoints.USER_PORTFOLIO, { user_id: userData?.id }).then((res: any) => {
            if (res?.status?.code == 200) {
                setPreviews(res?.results?.length > 0 ? res?.results : [])
            }
        }).catch(emptyFunction)
    }

    const handleRemove = (item: any, idx: any) => {
        const previewsData = [...previews];
        if (item?.id) {
            const url = `${endPoints.USER_PORTFOLIO}${item?.id}/`
            makeDeleteCall(url).then((res) => {
                fetchUserPortfolio();
                previewsData.splice(idx, 1);
            }).catch(emptyFunction)
        } else {
            previewsData.splice(idx, 1)
        }
        setPreviews(previewsData)
    }

    useEffect(() => {
        fetchUserPortfolio()
    }, [])

    return (
        <RegisterLayout showLogout hideHeader>
            <div className="register-step">
                {/* Heading block */}
                <div className="register-step__heading-block">
                    <h1 className="register-step__title media-step__title">Media</h1>
                    <p className="register-step__description">
                        Upload some examples of your work to share on your profile. Make
                        sure you are allowed to share these, and they are not under NDA.
                    </p>
                </div>

                {/* Drop zone */}
                <div
                    className={`media-step__dropzone${dragging ? " media-step__dropzone--active" : ""}`}
                    onClick={() => fileInputRef.current?.click()}
                    onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
                    onDragLeave={() => setDragging(false)}
                    onDrop={handleDrop}
                >
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/jpg,image/jpeg,image/png"
                        multiple
                        hidden
                        onChange={(e) => handleFiles(e.target.files)}
                    />
                    <div className="media-step__dropzone-icon">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <rect x="2" y="8" width="36" height="26" rx="4" stroke="#a0aec0" strokeWidth="2" fill="none" />
                            <circle cx="14" cy="18" r="4" stroke="#a0aec0" strokeWidth="2" fill="none" />
                            <path d="M2 30l10-8 8 6 6-5 12 7" stroke="#a0aec0" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </div>
                    <p className="media-step__dropzone-text">
                        <span className="media-step__dropzone-link">Click to upload</span>
                        {" "}or drag and drop
                    </p>
                    <p className="media-step__dropzone-hint">JPG, JPEG, PNG less than 1MB</p>
                </div>

                {/* Preview grid */}
                {previews.length > 0 && (
                    <div className="media-step__previews">
                        {previews.map((item: any, i: any) => (
                            <div style={{ position: 'relative' }} key={i} className="media-step__preview-item">
                                <img src={item?.image} alt={`Upload ${i + 1}`} />
                                <img className="portfolio-deleticon" src="/assets/images/delete_profile_white.svg" alt="" onClick={() => handleRemove(item, i)} />
                            </div>
                        ))}
                    </div>
                )}

                <div className="register-step__footer">
                    <button
                        className="btn-next btn-next--yellow"
                        type="button"
                        style={{ marginRight: 15 }}
                        onClick={onPrevious}
                    >
                        Previous
                    </button>
                    <button
                        className="btn-next btn-next--yellow"
                        onClick={handleSubmit}
                        type="button"
                    >
                        Next
                    </button>
                </div>
            </div>
        </RegisterLayout>
    );
};

export default StepMedia;